import { type MouseEvent, useCallback, useState } from 'react';

export const useHover = (options?: {
  activeOnStart?: boolean;
  stopHoveringOnMenuItems?: boolean;
}): [boolean, { onMouseEnter: () => void; onMouseLeave: () => void }] => {
  const { activeOnStart = false, stopHoveringOnMenuItems = false } = options || {};
  const [isHovering, setIsHovering] = useState(activeOnStart);

  const onMouseEnter = useCallback(() => {
    setIsHovering(true);
  }, [setIsHovering]);

  const onMouseLeave = useCallback(() => {
    setIsHovering(false);
  }, [setIsHovering]);

  const onMouseMove = useCallback((e: MouseEvent<HTMLDivElement>) => {
    if (e.nativeEvent.target instanceof HTMLDivElement) {
      if (e.nativeEvent.target.role === 'menuitem') {
        setIsHovering(false);
      }
    }
  }, []);

  return [
    isHovering,
    {
      onMouseEnter,
      onMouseLeave,
      ...(stopHoveringOnMenuItems && {
        onMouseMove,
      }),
    },
  ];
};
